import { render, staticRenderFns } from "./TableDefaultCell.vue?vue&type=template&id=3cbf5208&scoped=true"
import script from "./TableDefaultCell.vue?vue&type=script&lang=js"
export * from "./TableDefaultCell.vue?vue&type=script&lang=js"
import style0 from "./TableDefaultCell.vue?vue&type=style&index=0&id=3cbf5208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf5208",
  null
  
)

export default component.exports